module.exports = require("./pt.d.ts");